import { useState } from 'react';
import { Link, useOutletContext } from 'react-router-dom';
import { ArrowLeft, Check, FilePenLine } from 'lucide-react';
import { PORTAL_ROUTES } from 'utils/constants';
import Header from 'components/Profile/Header';
import List from 'components/Profile/TreatmentConsents/List';
import Modal from 'components/Profile/TreatmentConsents/Modal';
import { isSigned, pendingForms, signedForms, signedLabel } from 'components/Profile/Consent/helper';

const TreatmentConsents = () => {
  const { sectionData, mergeSection }: any = useOutletContext();
  const [activeConsent, setActiveConsent] = useState(null);

  const consents = sectionData?.treatmentConsents || [];
  const pending = pendingForms(consents);

  const handleSigned = (data) =>
    mergeSection('treatment', consents.map((form) => (data || []).find(({ id }) => id === form.id) || form));

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <div className="min-h-0 flex-1 overflow-y-auto px-5 pb-7 pt-5 lg:px-10">
        <Link
          to={PORTAL_ROUTES.PROFILE}
          className="btn btn-sm btn-outline mb-4 gap-1.5 border-gray-200 bg-white font-semibold text-secondary-600 hover:border-gray-300 hover:bg-white hover:text-secondary-900"
        >
          <ArrowLeft size={14} /> All forms
        </Link>

        <div className="mb-5">
          <Header
            icon={FilePenLine}
            iconBg="bg-amber-100"
            iconColor="text-amber-600"
            title="Treatment consents"
            description="Consents for the treatment your dentist planned"
            completed={isSigned(consents)}
          />
        </div>

        {!consents.length && (
          <div className="rounded-xl border border-dashed border-gray-200 bg-secondary-50/50 px-4 py-8 text-center text-sm text-secondary-400">
            No treatment consents to sign right now.
          </div>
        )}

        <List
          title="Needs action"
          description="Sign before your appointment so we can start treatment on time."
          badge={<span className="shrink-0 text-sm font-bold text-amber-700">{pending.length} to sign</span>}
          consents={pending}
          onOpen={setActiveConsent}
        />

        <List
          title="Signed"
          badge={
            <span className="inline-flex shrink-0 items-center gap-1.5 rounded-full border border-success-200 bg-success-50 px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wider text-success-700">
              <Check size={12} strokeWidth={3} /> {signedLabel(consents)}
            </span>
          }
          consents={signedForms(consents)}
          onOpen={setActiveConsent}
        />
      </div>

      {activeConsent && (
        <Modal consent={activeConsent} onClose={() => setActiveConsent(null)} onSigned={handleSigned} />
      )}
    </div>
  );
};

export default TreatmentConsents;
